import { z } from "zod";
import stringSchema from "@/lib/utils/stringSchema";

const formSchema = z.object({
  subject:stringSchema({ key: "Subject", required: true }),
  description: stringSchema({ key: "Description", required: true }),
  due_date: z.date().optional().nullable(),
  priority_id: stringSchema({ key: "Priority", required: true }),
  ticket_type_id: stringSchema({ key: "Ticket Type", required: true }),
  sub_ticket_type_id: z.string().optional().nullable(),
  region_id: z.string().optional().nullable(),
  country_ids: z.array(z.string()).min(1, "Country is required"),
  function_id: stringSchema({ key: "Function", required: true }),
  sub_function_id: z.string().optional().nullable(),
  department_id: z.string().optional().nullable(),
  sub_department_id: z.string().optional().nullable(),
});

export default formSchema;